var utils = {
    setupAudioMutex: function setupAudioMutex() {
        var currentPlayingAudio = null;
        document.addEventListener('play', function (event) {
            var targetAudio = event.target;
            if (targetAudio.tagName === 'AUDIO' && targetAudio.classList.contains('splayer-audio')) {
                if (targetAudio !== currentPlayingAudio) {
                    if (currentPlayingAudio && !currentPlayingAudio.paused) {
                        currentPlayingAudio.pause();
                    }
                    currentPlayingAudio = targetAudio;
                }
            }
        }, true);
    }
};
export default utils;